import type { Perspective, PublicCity } from '../perspective';
import { ownSlots, tradePrices, tradeableSlots } from '../production';
import { leftOf, rightOf } from '../topology';
import type { PaymentContext } from './solver';

export function paymentContextFor(p: Perspective): PaymentContext {
  const n = p.cities.length;
  const me = p.cities[p.seat] as PublicCity;
  const left = p.cities[leftOf(p.seat, n)] as PublicCity;
  const right = p.cities[rightOf(p.seat, n)] as PublicCity;
  return {
    coins: me.coins,
    own: ownSlots(me),
    left: tradeableSlots(left),
    right: tradeableSlots(right),
    prices: tradePrices(me),
  };
}
